import React, { useEffect } from 'react'
import NumberFormat from '../numberformat';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import DefaultSettings from '../settings';
import Typography from '@material-ui/core/Typography';

export default function DomainCalVal(props) {
    const { required, label, value = null, items = [], name, helperText, error, fieldValues, disabled, handleFieldValue,tooltip ,contexthelp} = props;

    useEffect(() => {
        if (fieldValues['LandUse'] && fieldValues['Unit'] && items && items.length > 0) {
            let item = items.find(each => each.Value === fieldValues['LandUse'])
            let val = item ? fieldValues['Unit'] * item.CalculatedValue : fieldValues['Unit'];
            let events = { target: { value: val.toFixed(2), name: name, checked: false } }
            handleFieldValue(events);
        }
    }, [fieldValues['LandUse'], fieldValues['Unit']])

    let tlabel = <Typography variant='subtitle2' color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
    {tooltip && <Tooltip title={tooltip ? tooltip : null}
        placement="bottom-start" >
        <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
            onClick={(evt) => contexthelp ?
                DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
    </Tooltip>}
</Typography>
    return (
        <NumberFormat xtype='DN' label={label} value={value} name={name} required={required} error={error} helperText={helperText}
         disabled={disabled} tooltip={props.tooltip} contexthelp={props.contexthelp}
            handleFieldValue={handleFieldValue} />
    )
}
